import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ResponsivePicture } from "../../../../Shared/components/Image";
import { Pager } from "../../../../Shared/components/Pager";
import { renderContents } from "../../components/jumbo";
import { Link } from "../../components/library/link";
import { SearchBar } from "../searchBar/searchBarLayout";
import { emptySearchResult } from "../searchPage/searchPageState";
const React = require("react");
const displayBundle = (bundle)=>{
    if (bundle == "activity") return "Activiteit";
    if (bundle == "faq") return "FAQ";
    if (bundle == "location_detail") return "Vestiging";
    if (bundle == "vacancy") return "Vacature";
    if (bundle == "sections") return "Sectie";
    if (bundle == "collection_overview") return "Collectieoverzicht";
    if (bundle == "report") return "Terugblik";
    if (bundle == "blog_post") return "Blog";
    if (bundle == "news_item") return "Nieuws";
    if (bundle == "activity_clusters") return "Activiteiten overzicht";
    if (bundle == "blog_overview") return "Blog overzicht";
    if (bundle == "location_overview") return "Zalen overzicht";
    if (bundle == "news_overview") return "Nieuws overzicht";
    if (bundle == "report_overview") return "Terugblikken overzicht";
    return "Pagina";
};
export const SearchPageLayout = (props)=>{
    const { searchQuery, searchResults, currentPage, pageSize, updatePage, updateQuery, runQuery } = props;
    const { totalResults, results, query: currentQuery, page: resultPage } = searchResults.kind == 'loaded' ? searchResults.value : emptySearchResult;
    const pager = totalResults ? Pager({
        currentPage,
        pageSize,
        totalResults,
        setPage: (page)=>updatePage(page)
    }) : /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx("header", {
                className: "jumbotron jumbotron--small jumbotron--search",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "jumbotron__inner container--mg align--center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__content",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "form form--search search--pageheader",
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "sr-text",
                                    children: "Zoeken"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "search__input-container form__item--icon left",
                                    children: /*#__PURE__*/ _jsx(SearchBar, {
                                        id: "site-search-page",
                                        query: searchQuery,
                                        updateSearchQuery: (newQuery)=>updateQuery(newQuery),
                                        runSearchQuery: ()=>runQuery()
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("section", {
                className: `search-results align--center search-results--${searchResults.kind}`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "search-results__inner",
                    children: results.length == 0 ? /*#__PURE__*/ _jsx("h2", {
                        className: "search-results__title title--s",
                        children: `Niets gevonden`
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "search-results__title title--s",
                                children: `${totalResults} ${totalResults == 1 ? "resultaat" : "resultaten"} ${currentQuery == "" ? "" : `voor \"${currentQuery}\"`}`
                            }),
                            /*#__PURE__*/ _jsx("ul", {
                                className: "teasers row",
                                children: results.map((result, index)=>/*#__PURE__*/ _jsx("li", {
                                        className: `teaser teaser--search teaser--image col-xs-12`,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            url: result.Url ? result.Url : "",
                                            className: "teaser__link",
                                            children: /*#__PURE__*/ _jsx("article", {
                                                className: "teaser__inner has-label",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "teaser__content",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "teaser__content-inner",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("header", {
                                                                    className: "teaser__header",
                                                                    children: /*#__PURE__*/ _jsx("h3", {
                                                                        className: "teaser__title",
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            children: result.Title
                                                                        })
                                                                    })
                                                                }),
                                                                result.Description && /*#__PURE__*/ _jsx("div", {
                                                                    className: "teaser__text",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "teaser__intro",
                                                                        children: renderContents(result.Description, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "teaser__meta",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "teaser__label",
                                                                children: displayBundle(result.Bundle)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "teaser__visual",
                                                            "aria-hidden": "true",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(ResponsivePicture, {
                                                                    imgClassName: "teaser__image",
                                                                    defaultImageUrl: result.ImageUrls['4x3'],
                                                                    cropsPerMedia: [
                                                                        {
                                                                            crops: [
                                                                                {
                                                                                    url: result.ImageUrls['420x320'],
                                                                                    width: 420
                                                                                },
                                                                                {
                                                                                    url: result.ImageUrls['840x640'],
                                                                                    width: 840
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    width: 420,
                                                                    height: 320,
                                                                    alt: ""
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "teaser__hover",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, `${currentQuery}-${resultPage}-${index}`))
                            })
                        ]
                    })
                })
            }),
            pager
        ]
    }, "search-page");
};
